import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AppstateFacade,
  AppstateService,
} from '@cigna/cigna-for-brokers/shell/data-access';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ContactUsComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LoginFacade } from '@cigna/cigna-for-brokers/login-data-access';

@Component({
  selector: 'cigna-app-error',
  templateUrl: './app-error.component.html',
  styleUrls: ['./app-error.component.scss'],
})
export class AppErrorComponent implements OnInit, OnDestroy {
  isShowErrMessage = false;
  currentYear: string = new Date().getFullYear().toString();
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  isOktaLoginEnabled: boolean;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private appStateService: AppstateService,
    private appstateFacade: AppstateFacade,
    public dialog: MatDialog,
    private featureTogglesFacade: FeatureTogglesFacade,
    public loginFacade: LoginFacade,
  ) {}

  ngOnInit(): void {
    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOktaLoginEnabled) => {
        this.isOktaLoginEnabled = isOktaLoginEnabled;
      });
  }

  naviagateToLogin() {
    if (this.isOktaLoginEnabled) {
      // this.router.navigate(['/public/login']);
      this.loginFacade.logout('logout');
    } else {
      // this.router.navigate(['/']);
      this.appstateFacade.logOut({ variation: 'logout', linkName: 'logout' });
    }
    this.isShowErrMessage = false;
  }
  showContactModal() {
    this.dialog.open(ContactUsComponent, {
      width: '60rem',
      autoFocus: false,
      disableClose: true,
    });
  }

  ngOnDestroy(): void {
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }
}
